import { render, staticRenderFns } from "./time-range-widget.vue?vue&type=template&id=dfbb506e&scoped=true"
import script from "./time-range-widget.vue?vue&type=script&lang=js"
export * from "./time-range-widget.vue?vue&type=script&lang=js"
import style0 from "./time-range-widget.vue?vue&type=style&index=0&id=dfbb506e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb506e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfbb506e')) {
      api.createRecord('dfbb506e', component.options)
    } else {
      api.reload('dfbb506e', component.options)
    }
    module.hot.accept("./time-range-widget.vue?vue&type=template&id=dfbb506e&scoped=true", function () {
      api.rerender('dfbb506e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/time-range-widget.vue"
export default component.exports